import type { ServiceCategoryRow } from '@/api/booking/getServiceCategoriesQuery';
import type { Service } from '@/types/booking';
import { getSubcategoryCounts } from '@/utils/booking/getSubcategoryCounts';
import { getVisibleL1Categories } from '@/utils/booking/getVisibleL1Categories';
import { getVisibleL2Categories } from '@/utils/booking/getVisibleL2Categories';

interface GetL1CategoriesWithSubcategoriesParams {
  rows: ServiceCategoryRow[];
  services: Service[];
  cartServices: Service[];
  requireBarberAssignment: boolean;
}

/**
 * Returns the visible L1 rows that have at least one L2 the L2 list would
 * show, counted with the same inputs as that list, so a listed L1 never opens
 * an empty L2 screen.
 */
export function getL1CategoriesWithSubcategories({
  rows,
  services,
  cartServices,
  requireBarberAssignment,
}: GetL1CategoriesWithSubcategoriesParams): ServiceCategoryRow[] {
  const allowedL1Ids = new Set(
    getVisibleL1Categories({ rows })
      .filter(
        ({ id }) =>
          getVisibleL2Categories({
            l1Id: id,
            rows,
            counts: getSubcategoryCounts({
              l1Id: id,
              rows,
              services,
              cartServices,
              requireBarberAssignment,
            }),
          }).length > 0,
      )
      .map(({ id }) => id),
  );
  return getVisibleL1Categories({ rows, allowedL1Ids });
}
